export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.82b050fd.svg";